import React from 'react';
import { Button } from 'app/blocks/buttons/buttons';
import DialogMessage from 'app/blocks/dialog/dialog__message';
import Modal from 'app/blocks/Modal/Modal';

export default function OrdersOAModalError(props) {
    const html = props.errorMessage || props.html || props.message;
    const innerContent = props.innerContent || props.text;
    const closeButtonText = props?.closeButtonText || 'Close';

    return (
        <Modal className="Dialog" ignoreBackdropClicks onClose={props.onClose} type="error">
            <form>
                <div className="modal-body Dialog-Body" data-seleniumid="modal-body">
                    <div>
                        <DialogMessage html={html} innerContent={innerContent} type="error" />
                        {props.refId && (
                            <div className="Dialog-RefId" data-seleniumid="dialog-refId">
                                {`refId: ${props.refId}`}
                            </div>
                        )}
                    </div>
                    <div className="Dialog-BodyActions Dialog-BodyActions-Column">
                        <Button data-seleniumid="order-oa-cancel-button" onClick={props.onClose}>
                            {closeButtonText}
                        </Button>
                        {props.onEdit && (
                            <Button data-seleniumid="order-oa-edit-button" onClick={props.onEdit}>
                                Edit
                            </Button>
                        )}
                        {props.onGoSupport && (
                            <Button data-seleniumid="order-oa-edit-button" onClick={props.onGoSupport}>
                                Wiley Support
                            </Button>
                        )}
                    </div>
                </div>
            </form>
        </Modal>
    );
}
